<template>
  <div class="margin-neg">
    <b-row >
      <b-col md="1" sm="2">
        <b-form-group
            id="status"
            label="Status"
            label-for="status-select"
        >
          <b-form-select id="status-select"
                         :plain="true"
                         :options="statusSelects"
                         v-model="statusSelect"
                         size="sm">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="5" md="5">
        <b-row>
          <b-col sm="3">
            <span>Zeitraum</span>
            <datetime
                style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem"
                v-model="currentDate"
                input-class="form-control form-control-sm"
                input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
                input-id="date"
                :phrases="datetimeConfig.phrases"
                :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                size="sm"
            ></datetime>
          </b-col>
          <b-col>
            <b-row>
              <b-col md="10">
                <b-form-radio-group
                    id="radio-slots"
                    name="radio-options-slots"
                    buttons
                    v-model="selectedDateType"
                    button-variant="secondary"
                >
                  <b-form-radio value="D" style="display: flex; flex-direction: column">
                    <!--day-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></day-icon-->
                    <span class="calendar-item"><b>1</b></span>
                    Tag
                  </b-form-radio>
                  <b-form-radio value="W" style="display: flex; flex-direction: column">
                    <!--week-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></week-icon-->
                    <span class="calendar-item"><b>7</b></span>
                    Woche
                  </b-form-radio>
                  <b-form-radio value="M" style="display: flex; flex-direction: column">
                    <!--month-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></month-icon-->
                    <span class="calendar-item"><b>31</b></span>
                    Monat
                  </b-form-radio>
                  <b-form-radio value="Y" style="display: flex; flex-direction: column">
                    <!--year-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></year-icon-->
                    <span class="calendar-item"><b>{{new Date(Date.parse(this.currentDate)).getFullYear() - 2000}}</b></span>
                    Jahr
                  </b-form-radio>
                  <b-form-radio value="G" style="display: flex; flex-direction: column">
                    <!--all-icon class="icon-1_5x ic-chevron" fillColor="#ac121b" :size="72" style="position: inherit;" ></all-icon-->
                    <span class="calendar-item"><b>&lt=</b></span>
                    Gesamt
                  </b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="1" style="padding-bottom: 1rem; text-align: end;" class="ml-auto">
        <refresh-icon class="icon-2x ic-chevron mt-auto" :size="72" style="position:absolute; bottom:1rem; right:1rem;" @click="searchFilter"></refresh-icon>
      </b-col>
      <b-col sm="2" md="2" style="padding-bottom: 1rem"
             v-on:keypress.enter="searchText">
        <b-form-input
            style="position:absolute; bottom:1rem; left:0;"
            v-model="fullTextSearch"
            placeholder="Suche"></b-form-input>
      </b-col>
      <b-col sm="2" md="1" style="padding-bottom: 1rem">
        <b-button style="position:absolute; bottom:1rem; left:12px;"
                  v-on:click="searchText"
                  variant="primary"
                  class="px-4 mr-3 mt-auto">Suchen
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {DateTime as LuxonDateTime} from "luxon";
import Chevron from 'vue-material-design-icons/ChevronDown.vue';
import DayIcon from 'vue-material-design-icons/AlphaTBoxOutline.vue';
import WeekIcon from 'vue-material-design-icons/AlphaWBoxOutline.vue';
import MonthIcon from 'vue-material-design-icons/AlphaMBoxOutline.vue';
import YearIcon from 'vue-material-design-icons/AlphaJBoxOutline.vue';
import AllIcon from 'vue-material-design-icons/CodeLessThanOrEqual.vue';
import RefreshIcon from 'vue-material-design-icons/Refresh.vue';
import VJstree from 'vue-jstree'

export default {
  components: {Chevron, DayIcon, WeekIcon, MonthIcon, YearIcon, AllIcon,VJstree, RefreshIcon},
  props: {
    onSearch: {
      type: Function,
      default: undefined
    },
    selectedDate: {
      default: () => null
    },
  },
  name: "PlanningListSearchbar",
  computed: {
    showYear() {
      return true;
    }
  },
  data: () => {
    return {
      fullTextSearch: "",
      wasMounted: false,
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, minTime: LuxonDateTime.local().toISO()},
      currentDate: null,
      statusSelect: "O",
      statusSelects: [
        {text: "Alle", value: "A"},
        {text: "Offen", value: "O"},
        {text: "Fertiggestellt", value: "F"},
      ],
      selectedDateType: "M",
    }
  },
  methods: {
    getCurrentType() {
      return this.statusSelect;
    },
    searchText() {
      if (this.onSearch !== undefined) {
        console.log("searchText triggered")

        this.onSearch(
            this.statusSelect,
            this.currentDate,
            this.selectedDateType,
            this.fullTextSearch,
        )
      }
    },
    searchFilter() {
      if (this.onSearch !== undefined) {
        this.onSearch(
            this.statusSelect,
            this.currentDate,
            this.selectedDateType,
            this.fullTextSearch,
        )
      }
    },
    onFirstSearch() {
      this.wasMounted = true;
    },
  },
  watch: {
    selectedDate: function(newVal, oldVal) {
      this.currentDate = newVal;
    },
    currentDate: function(newVal, oldVal) {
      if (newVal && oldVal && newVal.split("T")[0] === oldVal.split("T")[0]) {
        return
      }
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    statusSelect: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
    selectedDateType: function(newVal, oldVal) {
      if (this.wasMounted) {
        this.searchFilter();
      }
    },
  }
}
</script>

<style scoped>

::v-deep .btn.active > .calendar-item {
  color: black;
  border-color: black;
}
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}
.ic-chevron {
  color: #696969;
  vertical-align: middle;
  cursor: pointer;
  margin: 0px;
}
::v-deep .material-design-icon > .material-design-icon__svg {
  bottom: inherit;
}

::v-deep .refresh-icon > .material-design-icon__svg {
  bottom: auto !important;
}

::v-deep .btn.btn-secondary {
  background: white;
  cursor: pointer;
}
.calendar-item {
  height: 1.5rem;
  width: 1.5rem;
  position: inherit;
  vertical-align: middle;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  align-self: center;
  color: #696969;
}

::v-deep .tree-icon.none {
  display: none;
}
</style>

<style>
.no-select{
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.ic-chevron > .material-design-icon__svg {
  position: inherit !important;
}
</style>
